import React, { useState, useRef } from "react";
import { Col, Row, Container, Form } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import ManualDataPull from "client_config/ManualDataPull";
import GoogleAnalyticsIds from "client_config/seo_config/ids/GoogleAnalyticsIds";
import SemrushIds from "client_config/seo_config/ids/SemrushIds";
import CustomFormCheck from "utils/CustomFormCheck";
import GoogleAnalyticsGoals from "client_config/seo_config/ids/GoogleAnalyticsGoals";
import CurrencySelector from "client_config/CurrencySelector";
import jsDig from "utils/jsDig";

export default function IDs(props) {
  const platformData = props.seo_section.platform_data;
  const customAnalyticsGoals = props.seo_section.custom_analytics_goals;
  const customAnalyticsGoalsEnabled = props.seo_section.custom_analytics_goals_enabled;
  const analyticsAccounts = jsDig(["google_analytics", "account_ids"], platformData) ? jsDig(["google_analytics", "account_ids"], platformData) : [];
  const checkRef = useRef(null);
  let platforms = [
    {
      name: "pull_google_data",
      id: "google_analytics",
      label: "Pull Google Data",
    },
    {
      name: "pull_search_console_data",
      id: "search_console",
      label: "Pull Search Console Data",
    },
    {
      name: "pull_semrush_data",
      id: "semrush",
      label: "Pull SEMRush Data",
    },
  ];

  const [baseCurrency, setBaseCurrency] = useState(props.seo_section.base_currency)
  const [displayCurrency, setDisplayCurrency] = useState(props.seo_section.display_currency)

  return (
    <Container fluid className="p-3 pl-md-0 pt-2 seo-config-tab-content" style={{ backgroundColor: "#EEEEEE" }}>
      <div className="idForm m-0 pl-0 pl-lg-4 mr-4">
        <Col className="pb-5 pt-4 idColumn" xs={12}>
          <Row className="pb-3">
            <Col className="">
              <div className="d-flex row align-items-center">
                <span className="green mb-0 visby-bold f18">Account IDs</span>
                <CustomTooltip
                  faClass="far green fa-question-circle f18 pl-2"
                  message="List your account IDs below for the specified platforms. This is how we will pull metrics into DataPulse, so it’s important that your IDs match exactly."
                  inline={true}
                />
              </div>
            </Col>
          </Row>
          <GoogleAnalyticsIds platformData={platformData} ga4Date={props.ga4_date} />
          <GoogleAnalyticsGoals customGoals={customAnalyticsGoals} customGoalsEnabled={customAnalyticsGoalsEnabled} analyticsAccounts={analyticsAccounts} />
          <SemrushIds platformData={platformData} websites={props.client_account.websites} />
        </Col>
        <Col className="pt-3 pb-5 trim-padding-left trim-padding-right idColumn " xs={12}>
          <ManualDataPull isEnabled={props.seo_section.data_pull_enabled} platforms={platforms} service="seo" isAdmin={props.user_is_admin} />
          <div class="seo-config-semrush-target-location">
          <Row className=" ml-3 mt-5">
            <Col>
            <p className="primary pb-2">
            SEMRush target Location:
            </p>
            </Col>
          </Row>
          <Row className=" ml-3 mt-0">
            <Col>
            <Form.Control
              style={{ width: "216px" }}
              name="semrush_target_location"
              className="primary"
              size="md"
              as="select"
              defaultValue={jsDig(["seo_section", "semrush_target_location"], props)}
              >
              <option disabled hidden>
                  Target Location
                </option>
                <option value="local">Local</option>
                <option value="regional">Regional</option>
                <option value="national">National</option>
            </Form.Control>
            </Col>
          </Row>
          </div>
          <div class= "seo-config-property-is-a-domain-property">
          <Row className=" ml-3 mt-5">
            <CustomFormCheck id={`domain_property`} dynamic checked={props.seo_section.domain_property} name={`domain_property`} ref={checkRef} />
            <Col
              onClick={(e) => {
                e.preventDefault();
                checkRef.current.click();
              }}>
              Property is a domain property?
            </Col>
          </Row>
          </div>
          <div class="seo-config-currency" >
            <Row className="py-4 px-0 px-md-4">
              <Col xs={12} sm={6}>
                <h5 className="pl-1 py-2">Base Currency</h5>
                <CurrencySelector selectedCurrency={baseCurrency} setSelectedCurrency={setBaseCurrency} nameAttribute="seo_base_currency" />
              </Col>
              <Col xs={12} sm={6}>
                <h5 className="pl-1 py-2">Display Currency</h5>
                <CurrencySelector selectedCurrency={displayCurrency} setSelectedCurrency={setDisplayCurrency} nameAttribute="seo_display_currency" />
              </Col>
            </Row>
          </div> 
          {/* <RootDomains platformData={platformData} websites={props.client_account.websites} seo_section={props.seo_section} /> */}
        </Col>
      </div>
    </Container>
  );
}
